import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-show-details-hotel',
  templateUrl: './show-details-hotel.component.html',
  styleUrls: ['./show-details-hotel.component.scss'],
  standalone: false
})
export class ShowDetailsHotelComponent implements OnInit {
  @Input() detail: any;
  showDetails = false;

  constructor() {}

  ngOnInit(): void {}
}
